// Troncature « Voir plus » des textes longs du fil (PostCard, DiscoverPost) — façon Facebook :
// coupe à la 1re fin de paragraphe située après `minParagraph` caractères, sinon au dernier mot
// entier avant `maxChars`. La page /post/:id affiche toujours le texte complet.
export const FEED_TEXT_DEFAULT_CHARS = 420;
export const FEED_TEXT_MIN_PARAGRAPH = 300;

/** Admin › Paramètres › Limites — caractères affichés avant « Voir plus » dans le fil. */
export const feedTextMaxChars = (config) => {
  const n = Number(config?.settings?.feed_text_max_chars);
  return Number.isFinite(n) && n >= 120 ? Math.min(n, 2000) : FEED_TEXT_DEFAULT_CHARS;
};

export function clampText(text, maxChars = FEED_TEXT_DEFAULT_CHARS, minParagraph = FEED_TEXT_MIN_PARAGRAPH) {
  const full = String(text || "");
  if (full.length <= maxChars) return { shown: full, truncated: false };
  const floor = Math.min(minParagraph, maxChars);
  // 1re fin de paragraphe après `floor` (et avant la limite) → coupe propre entre deux paragraphes.
  const nl = full.indexOf("\n", floor);
  let cut = nl !== -1 && nl <= maxChars ? nl : -1;
  if (cut === -1) {
    const slice = full.slice(0, maxChars);
    const sp = slice.lastIndexOf(" ");
    cut = sp >= Math.floor(maxChars * 0.6) ? sp : maxChars;
  }
  const shown = full.slice(0, cut).replace(/[\s.,;:!?…-]+$/u, "");
  return { shown: `${shown}…`, truncated: true };
}
